// ...existing code...
import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/auth",
    name: "AuthPage",
    component: () => import("@/pages/AuthPage.vue"),
  },
  {
    path: "/login",
    name: "LoginPage",
    component: () => import("@/pages/LoginPage.vue"),
  },
  {
    path: "/change-password",
    name: "ChangePasswordPage",
    component: () => import("@/pages/ChangePasswordPage.vue"),
  },
  // {
  //   path: "/login",
  //   name: "loginPage",
  //   component: () => import("@/pages/loginPage.vue"),
  // },
  {
    path: "/",
    name: "HomePage",
    component: () => import("@/pages/HomePage.vue"),
  },
  {
    path: "/meeting",
    name: "MeetingPage",
    component: () => import("@/pages/MeetingPage.vue"),
  },
  {
    path: "/user",
    name: "UserPage",
    component: () => import("@/pages/UserPage.vue"),
  },
  {
    path: "/history",
    name: "HistoryPage",
    component: () => import("@/pages/HistoryPage.vue"),
  },
  {
    path: "/history/:id",
    name: "HistoryDetailPage",
    component: () => import("@/pages/HistoryDetailPage.vue"),
  },
  {
    path: "/allUsers",
    name: "AllUsersPage",
    component: () => import("@/pages/ViewAllUser.vue"),
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
